import { Box, Button, Checkbox, FormControlLabel, Tab, Tabs } from '@mui/material'
import { replaceParamsScript } from 'bets.oddprovider.lib.common.ts'
import { ApiRoutesNames } from 'bets.oddprovider.lib.common.ts/api/routes'
import { IDbTask, IDbTaskExecOptions, IDbTaskExecResult, IDbTaskExecResultStatus } from 'bets.oddprovider.lib.common.ts/models'
import { endpoinstAuths } from 'bets.oddprovider.lib.common.ts/models/authorizations'
import FileSaver from 'file-saver'
import { ArrayUtils, CommonUtils } from 'fwork-jsts-common/src'
import { ApiClientUtils, IApiClientResult } from 'fwork-jsts-common/src/apiClient'
import { FormItemStyled, FormStyled } from 'fwork.react.apptemplate'
import { CtrlParamsComponent, ctrlParamsComponentGetInitParams, ctrlParamsComponentValidateParams } from 'fwork.react.test/src/components/ctrlParams'
import { IParam } from 'fwork.react.test/src/components/ctrlParams/models'
import { FilterQuery } from 'mongoose'
import { useSnackbar } from 'notistack'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { FiDownload as FiDownloadIcon, FiUpload as FiUploadIcon } from "react-icons/fi"
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { io } from 'socket.io-client'
import axios from "../../apiClient/axios"
import { TasksApiClient } from '../../apiClient/tasks'
import { DEFAULTGAP, RoutesNames } from '../../globals'
import { IDotEnvProductionState } from '../../redux/reducers/dotenvProduction.slice'
import { toggleLoading } from '../../redux/reducers/loadingBar.slice'
import { dbTasksStateLoadFromApi, IDbTasksAction } from '../../redux/reducers/tasks.slice'
import { RootState } from '../../redux/store'
import { FloatActionButton } from '../common/floatActionButton'
import { HeaderComponent } from '../common/header'
import { SearchInputComponent } from '../common/searchInput'
import { DbTasksDatabasesComponent } from './databases'
import { DbConfirmTaskDialog } from './dbConfirmTaskDialog'
import { DbTaskHistoriesComponent } from './dbTaskResult'

export interface IDbTaskHistory {
  uuid: string,
  taskId: number,
  taskName: string,
  date: Date,
  dbTaskExecResult: IDbTaskExecResult[],
  // show?: boolean
}

export interface IDbTaskHistoryShowOptions {
  waiting: boolean,
  success: {
    show: boolean,
    onlyresultset: boolean,
  },
  error: boolean,
}

export const TasksComponent = (props: {
  refresh?: boolean | undefined
}) => {
  const navigate = useNavigate()
  const dispatch = useDispatch<any>()
  const { enqueueSnackbar } = useSnackbar()

  const authenticationState = useSelector((state: RootState) => state.authenticationState)
  const tasksState = useSelector((state: RootState) => state.tasksState)
  const dotEnvProductionState: IDotEnvProductionState = useSelector((state: RootState) => state.dotEnvProductionState)

  const [currTask, setCurrTask] = useState<IDbTask | undefined>()
  const [currentTaskTab, setCurrentTaskTab] = useState<number | undefined>(0);
  const [params, setParams] = useState<IParam[] | undefined>()
  const [overrideSql, setOverrideSql] = useState<string | undefined>()
  const [selectedDbListNames, setSelectedDbListNames] = useState<string[]>([])
  const [showValidateText, setShowValidateText] = useState<boolean | undefined>()
  const [dbTaskHistory, setDbTaskHistory] = useState<IDbTaskHistory[]>(JSON.parse(localStorage.getItem('@dbTaskHistory') ?? '[]'))
  const [openDbConfirmExecTaskDialog, setOpenDbConfirmExecTaskDialog] = useState<boolean>(false)
  const [showInactiveTasks, setShowInativeTasks] = useState<boolean | undefined>(false)
  const [searchTask, setSearchTask] = useState<string | undefined>()
  const [executingCurrTask, setExecutingCurrTask] = useState<boolean>(false)

  const [dbHistoryShowOptions, setDbHistoryShowOptions] = useState<IDbTaskHistoryShowOptions>({
    waiting: false,
    success: {
      show: true,
      onlyresultset: true,
    },
    error: true,
  })

  const dbTaskHistoryFiltered = dbTaskHistory.filter(h => {
    const status: IDbTaskExecResultStatus[] = []
    if (dbHistoryShowOptions.waiting) status.push(IDbTaskExecResultStatus.waiting)
    if (dbHistoryShowOptions.success.show) status.push(IDbTaskExecResultStatus.success)
    if (dbHistoryShowOptions.error) status.push(IDbTaskExecResultStatus.error)

    return h.dbTaskExecResult.some(r => status.includes(r.status) && (dbHistoryShowOptions.success.onlyresultset && r.status == IDbTaskExecResultStatus.success ? r.result_set?.length : true))
  })

  const socket = io(dotEnvProductionState.payload?.APIURL ?? '', { autoConnect: false, });
  socket.on('oddprovider-dbtask-exec-result', (args: IDbTaskExecResult) => {
    setDbTaskHistory(old => ([
      ...old.map(h => h.uuid == args.sessionUuid ? {
        ...h,
        dbTaskExecResult: [
          ...h.dbTaskExecResult.map(r => r.db_name == args.db_name ? {
            ...args
          } : r)
        ],
        // so exibe se tiver resultado
        // show: h.dbTaskExecResult.some(r => r.result_set || r.status == IDbTaskExecResultStatus.error) || args.result_set || args.status == IDbTaskExecResultStatus.error ? true : false
      } : h),
    ]))
  })

  useEffect(() => {
    const s = localStorage.getItem('@dbTaskHistoryShowOptions')
    if (s)
      setDbHistoryShowOptions(JSON.parse(s))
    if (!tasksState.payload?.length)
      loadTasks()

    socket.connect()
  }, [])

  useEffect(() => {
    loadTasks()
  }, [props.refresh])

  useEffect(() => {
    if (tasksState.payload?.length) {
      setCurrTask(tasksState.payload[0])
      setCurrentTaskTab(0)
    }
  }, [tasksState.payload])

  useEffect(() => {
    setParams(ctrlParamsComponentGetInitParams(currTask?.screen_ctrols ?? []))
    setShowValidateText(false)
  }, [currTask])

  useEffect(() => {
    localStorage.setItem('@dbTaskHistory', JSON.stringify(dbTaskHistory))
  }, [dbTaskHistory])

  useEffect(() => {
    localStorage.setItem('@dbTaskHistoryShowOptions', JSON.stringify(dbHistoryShowOptions))
  }, [dbHistoryShowOptions])

  const loadTasks = async () => {
    dispatch(toggleLoading())

    let where: FilterQuery<IDbTask> | undefined = {
      $and: [
        {
          active: showInactiveTasks ? { $in: [null, false, true] } : true
        },
      ]
    }

    if (searchTask) {
      where.$and?.push({
        $or: [
          {
            name: { $regex: searchTask, $options: 'i' },
          },
          {
            id: Number(searchTask),
          }
        ]
      })
    }

    const response = await dispatch(dbTasksStateLoadFromApi({
      where,
      onFinally: () => {
        dispatch(toggleLoading())
      },
      onError: (msg) => {
        enqueueSnackbar(ApiClientUtils.getErrorMessage(msg), { variant: 'error' })
      }
    }))
  }

  const checkCanExecCurrTask = () => {
    if (!currTask) return
    if (executingCurrTask) return

    setShowValidateText(true)
    if (!ctrlParamsComponentValidateParams(currTask.screen_ctrols ?? [], params ?? [])) return

    if (!selectedDbListNames.length) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage('Nenhum banco selecionado'), { variant: 'error' })
      return
    }

    return true
  }

  const execCurrTask = async () => {
    if (!checkCanExecCurrTask()) return

    setExecutingCurrTask(true)

    let sessionUUid = CommonUtils.getNewUuid()
    const body: IDbTaskExecOptions = {
      sessionUuid: sessionUUid,
      task_id: currTask!.id,
      params,
      db_list_names: selectedDbListNames,
      override_sql: overrideSql
    }

    try {
      const response: IApiClientResult<IDbTaskExecResult[]> | undefined = await new TasksApiClient(axios).exec(body)

      if (response?.success)
        setDbTaskHistory(old => [
          ...old,
          {
            uuid: sessionUUid,
            taskId: currTask!.id,
            taskName: currTask!.name,
            date: new Date(),
            dbTaskExecResult: selectedDbListNames.map(dbname => ({
              db_name: dbname,
              msg: 'Aguardando...',
              status: IDbTaskExecResultStatus.waiting,
            } as IDbTaskExecResult))
          }
        ])

      setTimeout(() => {
        // setDbTaskHistory(old => ([
        //   ...old.map(h => h.uuid == sessionUUid ? {
        //     ...h,
        //     dbTaskExecResult: [
        //       ...h.dbTaskExecResult.map(r => r.status == IDbTaskExecResultStatus.waiting ? {
        //         ...r,
        //         msg: 'Tempo de resposta expirado',
        //         status: IDbTaskExecResultStatus.error,
        //       } : r)
        //     ],
        //     show: true
        //   } : h),
        // ]))
        const hasWaitingStatus = dbTaskHistory.some(h =>
          h.dbTaskExecResult.some(r => r.status === IDbTaskExecResultStatus.waiting)
        );

        if (hasWaitingStatus) {
          setDbTaskHistory(old => ([
            ...old.map(h => h.uuid === sessionUUid ? {
              ...h,
              dbTaskExecResult: [
                ...h.dbTaskExecResult.map(r => r.status === IDbTaskExecResultStatus.waiting ? {
                  ...r,
                  msg: 'Tempo de resposta expirado',
                  status: IDbTaskExecResultStatus.error,
                } : r)
              ],
              // show: true
            } : h),
          ]));
        }
      }, (1000 * 30));

    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    }
    finally {
      setExecutingCurrTask(false)
      setOpenDbConfirmExecTaskDialog(false)
      setOverrideSql(undefined)
    }
  }

  const exportToJson = () => {
    var fileName = 'dbTasks.json';

    var fileToSave = new Blob([JSON.stringify(tasksState.payload, undefined, 2)], {
      type: 'application/json'
    });

    FileSaver.saveAs(fileToSave, fileName);
  }

  let uploading = false
  const uploadFile = async (event: any) => {
    const fileSelected = event.target.files[0]

    if (uploading) return

    uploading = true

    try {
      if (fileSelected) {
        const response = await new TasksApiClient(axios).import(fileSelected)
        if (response.success == true) {
          enqueueSnackbar('Operação realizada com sucesso.', { variant: 'success' })
          loadTasks()
        }
        else
          enqueueSnackbar(response.msg || 'Erro ao importar as tarefas', { variant: 'error' })
      }
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    }
    finally {
      uploading = false
    }
  }

  const handleExecTaskButtonClick = () => {
    if (!checkCanExecCurrTask()) return

    let canEdit = false
    let endPointSettings = endpoinstAuths.filter(e => e.endpoint == ApiRoutesNames.dbTasks && e.method == 'PUT')[0]
    if (endPointSettings) {
      let intersection = ArrayUtils.intersection(authenticationState.payload?.user.authorization_ids ?? [], endPointSettings.auths)
      if (intersection.length)
        canEdit = true
    }
    if (canEdit)
      setOpenDbConfirmExecTaskDialog(true)
    else
      execCurrTask()
  }

  const getHandleEditTask = () => {
    let endPointSettings = endpoinstAuths.filter(e => e.endpoint == ApiRoutesNames.dbTasks && e.method == 'PUT')[0]
    if (endPointSettings) {
      let intersection = ArrayUtils.intersection(authenticationState.payload?.user.authorization_ids ?? [], endPointSettings.auths)
      if (intersection.length && currTask)
        return () => {
          navigate(RoutesNames.task.replace(':id', currTask.id.toString()))
        }
    }

    return undefined
  }

  return <>
    <DbConfirmTaskDialog
      open={openDbConfirmExecTaskDialog}
      onClose={() => setOpenDbConfirmExecTaskDialog(false)}
      onCancelClick={() => setOpenDbConfirmExecTaskDialog(false)}
      scriptSql={replaceParamsScript(currTask?.script_sql || '', params)}
      onConfirmClick={() => {
        setOpenDbConfirmExecTaskDialog(false)
        execCurrTask()
      }}
      onChange={e => setOverrideSql(e.target.value)}
    />

    <div style={{
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      paddingBottom: DEFAULTGAP
    }}>
      <HeaderComponent
        props={{
          style: {
            paddingInline: DEFAULTGAP
          }
        }}
        title='Tarefas'
        toolTipAdd={'Adicionar'}
        toolTipRefresh={'Atualizar'}
        onRefreshClick={() => {
          loadTasks()
        }}
        onAddClick={() => navigate(RoutesNames.task)}
        customActions={[
          {
            icon: <FiDownloadIcon size={25} />,
            toolTip: 'Baixar arquivo',
            action: () => exportToJson(),
            show: tasksState.payload?.length ? true : false
          },
          {
            icon:
              <>
                <input style={{ display: 'none' }} accept="application/JSON" id="upload" type='file' onChange={uploadFile} />
                <label htmlFor="upload" style={{ position: 'absolute', top: 10 }}>
                  <FiUploadIcon size={25} />
                </label>
              </>,
            toolTip: 'Enviar arquivo',
            action: () => { },
            show: true
          }]}
      />

      <SearchInputComponent
        style={{
          maxWidth: 500,
          marginInline: DEFAULTGAP,
        }}
        label='Pesquisar por código ou nome'
        onChange={e => setSearchTask(e.target.value)}
        onKeyUp={e => { if (e.key === "Enter") loadTasks() }}
        onIconClick={loadTasks}
      />

      <FormStyled gap={DEFAULTGAP}>
        <FormItemStyled gap={DEFAULTGAP}>
          <FormControlLabel
            control={
              <Checkbox
                checked={showInactiveTasks ? true : false}
                onChange={e => {
                  setShowInativeTasks(e.target.checked)
                }} />
            }
            label='Exibir tarefas inativas' />

        </FormItemStyled>


        {tasksState.payload?.length ? <FormItemStyled gap={DEFAULTGAP} fullWidth style={{
          boxShadow: 'rgba(0, 0, 0, 0.16) 1px 1px 3px',
          borderRadius: 8
        }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              width: '100%',
              boxSizing: 'border-box',
              border: '1px solid #ECECED',
              borderRadius: 2,
              maxHeight: 500,
            }}
          >
            <DbTasksDatabasesComponent
              sx={{
                borderRight: { md: '1px solid #ECECED' },
                borderBottom: { xs: '1px solid #ECECED', md: 'none' },
              }}
              style={{
                overflowY: 'auto',
                overflowX: 'hidden',
                minHeight: '50%',
              }}
              onGetDbSelected={(dbNames: string[]) => {
                setSelectedDbListNames(dbNames)
              }}
            />

            <Box
              style={{
                flexGrow: 1,
                boxSizing: 'border-box',
                // if not present, tabs overflow
                overflow: 'auto',
                minHeight: '50%',
              }}
            >
              <Tabs value={currentTaskTab}
                aria-label='tabs'
                onChange={(event: React.SyntheticEvent, newValue: number) => {
                  setCurrentTaskTab(newValue)
                }}
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
                style={{
                  borderBottom: '1px solid #ECECED',
                }}
              >
                {tasksState?.payload?.map((task, idx) =>
                  <Tab
                    iconPosition='start'
                    key={idx}
                    label={<span style={{
                      textDecoration: task.active ? undefined : 'line-through'
                    }}>{task.name}</span>}
                    onClick={() => {
                      setCurrTask(task)
                    }} />
                )}
              </Tabs>

              {currTask ? <>
                {currTask.active ? <></> : <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  background: '#ff5349',
                  padding: 8,
                  borderRadius: 5,
                  color: 'white',
                  marginTop: DEFAULTGAP,
                  marginLeft: DEFAULTGAP,
                  width: 160
                }}>
                  Tarefa desativada
                </div>}
                <CtrlParamsComponent
                  showValidateText={showValidateText}
                  gap={DEFAULTGAP}
                  ctrls={currTask?.screen_ctrols}
                  onChangeParamValues={(params) => setParams(params)}
                />

              </> : <></>}
            </Box>
          </Box>
        </FormItemStyled> : <></>}

        <FormItemStyled fullWidth gap={DEFAULTGAP}>
          <h5>Exibir histórico de...</h5>
          <div style={{ display: 'flex', flexDirection: 'row', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
            <FormControlLabel control={<Checkbox onChange={(e) => {
              setDbHistoryShowOptions((old) => ({
                ...old,
                waiting: e.target.checked
              } as IDbTaskHistoryShowOptions))
            }} checked={dbHistoryShowOptions?.waiting ?? false} defaultChecked />} label="Aguardando..." />
            <FormControlLabel control={<Checkbox onChange={(e) => {
              setDbHistoryShowOptions((old) => ({
                ...old,
                success: {
                  ...old?.success,
                  show: e.target.checked
                }
              } as IDbTaskHistoryShowOptions))
            }} checked={dbHistoryShowOptions?.success.show ?? false} defaultChecked />} label="Sucesso" />
            <FormControlLabel disabled={!dbHistoryShowOptions.success.show} style={{ fontStyle: 'italic', fontSize: 8, }} control={<Checkbox disabled={!dbHistoryShowOptions.success.show} onChange={(e) => {
              setDbHistoryShowOptions((old) => ({
                ...old,
                success: {
                  ...old?.success,
                  onlyresultset: e.target.checked
                }
              } as IDbTaskHistoryShowOptions))
            }} checked={dbHistoryShowOptions?.success.onlyresultset ?? false} defaultChecked />} label="Apenas com resultset" />
            <FormControlLabel control={<Checkbox onChange={(e) => {
              setDbHistoryShowOptions((old) => ({
                ...old,
                error: e.target.checked
              } as IDbTaskHistoryShowOptions))
            }} checked={dbHistoryShowOptions?.error ?? false} defaultChecked />} label="Erro" />
          </div>
        </FormItemStyled>

        {/* {dbTaskHistory.filter(h => h.show)?.length ? <FormItemStyled gap={DEFAULTGAP}
          fullWidth>
          <Button variant='contained' style={{ alignSelf: 'start' }} onClick={() => {
            localStorage.removeItem('@dbTaskHistory')
            setDbTaskHistory([])
          }} >Limpar Histórico</Button>

          <DbTaskHistoriesComponent style={{
            boxShadow: 'rgba(0, 0, 0, 0.16) 1px 1px 3px',
            border: '1px solid #ECECED',
            borderRadius: 8,
            width: '100%',
            marginTop: DEFAULTGAP
          }} data={dbTaskHistory.filter(h => h.show)} />
        </FormItemStyled> : <></>} */}
        {dbTaskHistoryFiltered?.length ? <FormItemStyled gap={DEFAULTGAP}
          fullWidth>
          <Button variant='contained' style={{ alignSelf: 'start' }} onClick={() => {
            localStorage.removeItem('@dbTaskHistory')
            setDbTaskHistory([])
          }} >Limpar Histórico</Button>

          <DbTaskHistoriesComponent style={{
            boxShadow: 'rgba(0, 0, 0, 0.16) 1px 1px 3px',
            border: '1px solid #ECECED',
            borderRadius: 8,
            width: '100%',
            marginTop: DEFAULTGAP
          }} data={dbTaskHistoryFiltered} />
        </FormItemStyled> : <></>}
      </FormStyled>
    </div>

    <FloatActionButton
      progress={executingCurrTask}
      onExecuteClick={handleExecTaskButtonClick}
      onEditClick={getHandleEditTask()}
    />
  </>
}